// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1EZWO","selects":"Documents_selects__2wk14"};